module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d3e3ad82daf219e08aae233ec9fef7cf.png";